import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as EmailValidator from 'email-validator';
import moment from 'moment';
import ExportDataRecord from './components/ExportDataRecord';
import RealTabSwitcher from '../../../Units/RealTabSwitcher';
import Checkbox from '../../../Units/Checkbox';
import ValidatedInput from '../../../Units/ValidatedInput';
import { exportDataRequest } from '../../../../store/actionCreators/club';
import { closeDialog } from '../../../../store/actionCreators/dialog';
import { getDialogParams } from '../../../../store/selectors';
import '../../../../assets/stylesheets/Dialogs/ExportData.scss';

const records = [
    {
        _id: 1,
        fromDate: '01.04.2020',
        toDate: '01.04.2020',
        exportDate: '01.04.2020',
        mail: 'Depart.adsfe@gmail.com',
        amount: 880,
        playerData: true,
        tradeRecord: true,
        sapphireStatement: true,
    },
    {
        _id: 2,
        fromDate: '01.04.2020',
        toDate: '01.04.2020',
        exportDate: '01.04.2020',
        mail: 'Depart.adsfe@gmail.com',
        amount: 880,
        playerData: true,
        tradeRecord: true,
        sapphireStatement: true,
    },
];

const renderRecord = (record) => (
    <ExportDataRecord data={record} key={record._id} />
);

const ExportData = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const params = useSelector(getDialogParams);

    const tabs = [
        { name: 'exportData' },
        { name: 'exportRecord' },
    ];

    const selected = 'exportData';
    const [email, setEmail] = useState('');
    const [emailIsValid, setEmailIsValid] = useState(undefined);
    const [tradeRecord, setTradeRecord] = useState(false);

    const onChangeEmail = useCallback((e) => {
        const email = e.target.value;
        setEmail(email);
    }, [setEmail, email]);

    const validateEmail = useCallback(() => {
        setEmailIsValid(EmailValidator.validate(email));
    },[email, emailIsValid]);

    const onConfirm = useCallback(() => {
        validateEmail();
        if (!emailIsValid) return false;
        dispatch(exportDataRequest(
          email,
          tradeRecord,
          moment(params.from).toISOString(),
          moment(params.to).toISOString(),
        ));
        dispatch(closeDialog());
    }, [email, emailIsValid, tradeRecord, params, validateEmail]);

    return (
        <div className="exportData">
            {
              selected === 'exportData' ?
              <div className={`exportDataTab exportDataTab--flex exportDataTab--padding ${selected === 'exportData' ? 'exportDataTab--visible' : ''}`}>
                  <div className="exportDataForm">
                      <div className="exportDataMail">
                          <label className="exportDataMailLabel">{t('pleaseEnterValidEmail')}</label>
                          <ValidatedInput
                              type="email"
                              value={email}
                              onChange={onChangeEmail}
                              valid={emailIsValid}
                              onBlur={validateEmail}
                          />
                          {!emailIsValid && emailIsValid!==undefined && 
                            <span className={`error`}>{t('invalidEmail')}</span>
                          }
                      </div>
                      <Checkbox
                          label={t('tradeRecord')}
                          checked={tradeRecord}
                          onChange={setTradeRecord}
                      />
                  </div>
                  <footer className="exportDataTabFooter">
                      <button className="exportDataSubmit" onClick={onConfirm}>{t('exportData')}</button>
                  </footer>
              </div> : (selected === 'exportRecord' &&
              {/*<div className={`exportDataTab ${selected === 'exportRecord' ? 'exportDataTab--visible' : ''}`}>
                  {records.map(renderRecord)}
              </div>*/})
            }
        </div>
    );
}

export default ExportData;
